<template>
  <div class="nav-container" :class="{ 'show' : showNav }">
    <nav>
      <router-link tag="div" class="tab" to="/projects" @click.native="$emit('hideNav')">
        <UsersIcon />
        <div>Users</div>
      </router-link>

      <router-link tag="div" class="tab" to="/devices" @click.native="$emit('hideNav')">
        <DevicesIcon />
        <div>Devices</div>
      </router-link>

      <div class="tab" @click="logOut">
        <PowerIcon />
        <div>Log Off</div>
      </div>
    </nav>
    <div class="overlay" @click="$emit('hideNav')"></div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import UsersIcon from '@/components/assets/UsersIcon';
import DevicesIcon from '@/components/assets/DevicesIcon';
import PowerIcon from '@/components/assets/PowerIcon';

export default {
  name: 'MobileNav',
  components: {
    PowerIcon,
    DevicesIcon,
    UsersIcon
  },
  props: ['showNav'],
  methods: {
    logOut() {
      firebase.auth().signOut()
        .then(() => {
          this.$router.replace({ name: 'login' })
          this.$emit('hideNav')
        })
        .catch((error) => console.log(error))
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../assets/styles/colors';
@import '../assets/styles/mixin';

.nav-container {

  &.show {

    nav {
      left: 0
    }

    .overlay {
      display: block;
    }
  }
}

nav {
  position: absolute;
  top: 0; left: -80%;
  width: 80%;
  height: 100vh;
  background-color: $gd_white;
  @include default-shadow(4px);
  box-sizing: border-box;
  padding-top: 8px;
  padding-left: 8px;
  transition: left .35s ease-out;
  z-index: 10;
}

.overlay {
  display: none;
  @include overlay();
  z-index: 9;
}

.tab {
  height: 48px;
  box-sizing: border-box;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  cursor: pointer;
  @include flex(row, flex-start, center);
  padding-left: 8px;

  div {
    margin-left: 32px;
    font-size: 16px;
  }

  &.router-link-active {
    background-color: $primary-shadow;

    svg, div {
      fill-opacity: 0.87;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobileNav.vue